/**
 * Start EC-543 [FE]
 * Create a redux store for Guest RFQ
 **/

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";


import { Draft } from "immer";

export interface GuestRFQCartState {
    isLoading: boolean;
    quoteCount: number;
}

const initialState: GuestRFQCartState = {
    isLoading: false,
    quoteCount:0,
};
const GuestRFQCartReducer = {
    "Custom/GuestRFQ/BeginLoadQuoteCount": (draft: Draft<GuestRFQCartState>) => {
        draft.isLoading = true;
    },
    "Custom/GuestRFQ/CompletedLoadQuoteCount": (
        draft: Draft<GuestRFQCartState>,
        action:{
            quoteCount: number
        }
    ) => {
        draft.quoteCount = action.quoteCount;
        draft.isLoading = false;
    },
};

export default createTypedReducerWithImmer(initialState, GuestRFQCartReducer);

/**
 * End EC-543 [FE]
 * Create a redux store for Guest RFQ
 **/
